import type { JsonValue } from '../../../common.types';

export const CardPointeLoggingRedactionOutcome = {
    REDACTED: 'redacted',
    MALFORMED_INPUT: 'malformed_input',
} as const;

export type CardPointeLoggingRedactionOutcome =
    (typeof CardPointeLoggingRedactionOutcome)[keyof typeof CardPointeLoggingRedactionOutcome];

export interface CardPointeLoggingRedactionRequestDetails {
    readonly payload: JsonValue;
}

export interface CardPointeLoggingRedactionNormalizedResult {
    readonly redacted_payload: JsonValue;
    readonly omitted_sensitive_key_count: number;
}

export type CardPointeLoggingRedactionResponseDetails =
    | {
          readonly outcome: typeof CardPointeLoggingRedactionOutcome.REDACTED;
          readonly normalized_result: CardPointeLoggingRedactionNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeLoggingRedactionOutcome.MALFORMED_INPUT;
          readonly message: string;
          readonly payload?: unknown;
      };
